import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header_container: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '1rem',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  quote_block_green: {
    marginTop: '.5rem',
    background: '#d8ffd8',
    borderLeft: '.5rem solid #00cc00',
    padding: '1rem',
  },
  quote_block_yellow: {
    marginTop: '.5rem',
    background: '#FFECB3',
    borderLeft: '.5rem solid #FFC107',
    padding: '1rem',
  },
  quote_block_blue: {
    background: '#B3E5FC',
    borderLeft: '.5rem solid #03A9F4',
    padding: '1rem',
  },
  container: {
    fontSize: '1rem',
    textAlign: 'right',
    padding: '.25rem 0',
  },
  value: {
    fontWeight: 'bold',
    width: '120px',
    display: 'inline-block',
    border: 'rgba(128, 128, 128, 0.2) solid 1px',
    borderRadius: '.5rem',
    padding: '.2rem',
    marginLeft: '1rem',
    color: 'red',
  },
}));

export default useStyles;
